import { createSlice } from "@reduxjs/toolkit";
import {
  fetchFilms,
  insertFilms,
  editFilms,
  deleteFilms,
  fetchFilmById,
  fetchFilmsByCategory,
} from "./FilmsThunks";

// Slice
const FilmsSlice = createSlice({
  name: "films",
  initialState: {
    fetchFilmspending: true,
    filmslist: null,
    fetchFilmsrejected: null,
    fetchFilmsIdrejected: null,
    filmsById: null,
    pagination: null,
    fetchFilmByIdpending: null,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFilms.pending, (state) => {
        state.fetchFilmspending = true;
      })
      .addCase(fetchFilms.fulfilled, (state, action) => {
        state.fetchFilmspending = false;
        if (action.payload?.pagination?.page == 1) {
          state.filmslist = action.payload.data;
        } else {
      
          action.payload.data.forEach((item) => {
            if (
              !state.filmslist.some(
                (existingItem) => existingItem._id === item._id
              )
            ) {
              state.filmslist.push(item);
            }
          });
        }
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchFilms.rejected, (state, action) => {
        state.fetchFilmspending = false;
        state.fetchFilmsrejected = action.payload;
      })
      .addCase(fetchFilmsByCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFilmsByCategory.fulfilled, (state, action) => {
        state.loading = false;

        state.filmslist = state.filmslist.filter(
          (item) => item.category === action?.payload?.data[0]?.category
        );

        action.payload.data.forEach((item) => {
          const exists = state.filmslist.some(
            (existingItem) => existingItem._id === item._id
          );
          if (!exists) {
            state.filmslist.push(item);
          }
        });

        state.pagination = action.payload.pagination || {};
      })

      .addCase(fetchFilmsByCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
        state.filmslist = [];
        state.pagination = null;
      })
      .addCase(fetchFilmById.pending, (state) => {
        state.fetchFilmByIdpending = true;
      })
      .addCase(fetchFilmById.fulfilled, (state, action) => {
        state.fetchFilmByIdpending = false;
        state.filmsById = action.payload;
      })
      .addCase(fetchFilmById.rejected, (state, action) => {
        state.fetchFilmByIdpending = false;
        state.fetchFilmsIdrejected = action.payload;
      });
  },
});
export const { resetinsertFilms, reseteditFilms, resetisDelete } =
  FilmsSlice.actions;
export default FilmsSlice.reducer;
